import { UserNotLoggedInError } from "./exception";
import { app } from "@/core/app";
/**
 * Get the current session user
 *
 * @throws {UserNotLoggedInError}
 */
export function currentUser() {
    if (app().user) {
        return app().user;
    }
    throw new UserNotLoggedInError();
}
